// Fursalogia — Brand Identity v2.0 (Sprint 33, 2026-08-06).
//
// This module is the ONLY place the official artwork is referenced.
// Every other component MUST import <Logo /> from here — never render
// the raw PNGs directly, never recolor the artwork, never crop it.
//
// v2 artwork: dark-brown + beige mark (upward-arrow diamond) with
// "FURSALOGIA · Opportunity Intelligence" wordmark.

import { HEADER } from "@/constants/testIds";

const ASSETS = Object.freeze({
  full:     "/brand/fursalogia-logo.png",     // Icon + wordmark stacked
  mark:     "/brand/fursalogia-mark.png",     // Icon only — for navbar / sidebar / mobile
  wordmark: "/brand/fursalogia-wordmark.png", // Text only — for brand strips, footers
});

// Height presets — width auto-scales via `object-fit: contain`.
// Preserves the master artwork's proportions exactly.
const SIZES = Object.freeze({
  xs:  { full: "h-10", mark: "h-6",  wordmark: "h-4"  },
  sm:  { full: "h-14", mark: "h-8",  wordmark: "h-5"  },
  md:  { full: "h-20", mark: "h-10", wordmark: "h-7"  },
  lg:  { full: "h-28", mark: "h-14", wordmark: "h-9"  },
  xl:  { full: "h-40", mark: "h-20", wordmark: "h-12" },
  "2xl": { full: "h-56", mark: "h-28", wordmark: "h-16" },
});

/**
 * Official Fursalogia logo.
 *
 * @param variant  "full" | "mark" | "wordmark"   — default "full"
 * @param size     preset key (xs sm md lg xl 2xl) — default "sm"
 * @param className extra classes (spacing / alignment only — never sizing overrides)
 * @param alt      accessible label — defaults to full brand.
 * @param testId   optional override; default preserves HEADER.logo so existing tests keep working.
 */
export const Logo = ({
  variant   = "full",
  size      = "sm",
  className = "",
  alt       = "Fursalogia — فرصالوجيا",
  testId,
}) => {
  const src   = ASSETS[variant]  || ASSETS.full;
  const scale = (SIZES[size] || SIZES.sm)[variant] || SIZES.sm.full;
  return (
    <img
      src={src}
      alt={alt}
      loading="eager"
      decoding="async"
      draggable="false"
      className={`${scale} w-auto select-none ${className}`}
      style={{ objectFit: "contain" }}
      data-testid={testId ?? HEADER.logo}
    />
  );
};

export default Logo;
